var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-right px-1.5 rounded text-xxs leading-4 p-px",class:[ _vm.item.isRefined ? 'text-EXPONDO-white bg-EXPONDO-primary-60' : 'bg-EXPONDO-grey-5' ]},[_vm._v("\n  "+_vm._s(_vm.item.count.toLocaleString())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }